import axios from "axios";
import AppSettings from "../appsettings";

const BASE_URL = `${AppSettings.API_BASE_URL}/PublisherBank`; 

const publisherBankService = {
  getAll: async () => {
    const response = await axios.get(BASE_URL);
    return response.data;
  },

  getByPublisherId: async (publisherId) => {
    const response = await axios.get(`${BASE_URL}/${publisherId}`);
    return response.data;
  },

  createOrUpdate: async (data) => {
    const response = await axios.post(BASE_URL, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.data;
  },
};

export default publisherBankService;
